export type Locale = 'zh-CN' | 'en';

const messages = {
  'zh-CN': {
    staff: '制作人员',
    relatedSubjects: '关联条目',
    expandAll: '展开全部',
    collapse: '收起',
    home: '首页',
    homeTitle: '发现',
    homeEmpty: '首页暂未显示任何内容',
    homeEmptyDescription: '请前往设置页面调整需要显示的首页板块。',
    homeEmptyAction: '调整首页显示',
    watchLater: '稍后再看',
    addWatchLater: '加入稍后再看',
    removeWatchLater: '移出稍后再看',
    noWatchLater: '暂无稍后再看的章节',
    noContinueWatching: '暂无未看完的内容',
    watchedPercent: '已观看 {percent}%',
    finishedWatching: '已看完',
    watchedAt: '观看时间 {time}',
    popular: '高热度',
    todayUpdates: '今日更新',
    myCollections: '我的收藏',
    collectionRecords: '追番记录',
    collectionStatusFilter: '追番状态',
    noCollectionRecords: '暂无追番记录',
    viewMore: '更多',
    dateUnknown: '日期未知',
    my: '我的',
    watchHistory: '历史记录',
    noWatchHistory: '暂无历史记录',
    schedule: '时间表',
    scheduleFollowingOnly: '只显示我的追番',
    scheduleDataSource: '播出数据由 bangumi-data 提供',
    recommendations: '推荐',
    randomAnime: '随机',
    episodeAired: '已播出',
    episodeUpcoming: '未播出',
    selectAllEpisodes: '全选章节',
    selectedEpisodes: '已选章节',
    episodeUnwatched: '未看',
    episodeWish: '想看',
    episodeWatched: '看过',
    episodeDropped: '抛弃',
    markEpisodeStatus: '标记状态',
    markAs: '标记为',
    episodeStatusUpdated: '章节状态已更新',
    episodeLayout: '章节显示方式',
    multiSelect: '多选',
    exitSelection: '退出选择',
    episodeGridView: '切换为网格显示',
    episodeListView: '切换为列表显示',
    loadMore: '加载更多',
    searchPlaceholder: '搜索动画…',
    searchResults: '搜索结果',
    animeType: '类型',
    region: '地区',
    source: '来源',
    rating: '评分',
    sort: '排序',
    noLimit: '不限',
    movie: '剧场版',
    japan: '日本',
    china: '中国',
    western: '欧美',
    original: '原创',
    mangaAdaptation: '漫画改',
    novelAdaptation: '小说改',
    gameAdaptation: '游戏改',
    sortHeat: '热度',
    sortScore: '评分',
    sortRank: '排名',
    sortMatch: '匹配度',
    summary: '简介',
    episodes: '章节',
    characters: '角色与声优',
    collectionStatus: '收藏状态',
    collectionNone: '未收藏',
    collectionWish: '想看',
    collectionDone: '看过',
    collectionDoing: '在看',
    collectionOnHold: '搁置',
    collectionDropped: '抛弃',
    collectionAll: '全部',
    openBangumi: '在 Bangumi 打开',
    airDate: '开播日期',
    airTime: '放送时间',
    airTimeUnknown: '时间待定',
    platform: '平台',
    episodeCount: '话数',
    contentUnavailable: '暂无内容，请确认 Bangumi Token 已配置',
    noContent: '暂无内容',
    changePassword: '修改密码',
    account: '账号',
    clearWatchHistory: '清空观看记录',
    clearWatchHistoryDescription: '清空当前账号保存的播放进度，不会删除下载任务或本地文件。',
    confirmClearWatchHistory: '确认清空观看记录？',
    confirmClearWatchHistoryDescription: '当前账号的全部播放进度将被永久删除，此操作无法撤销。',
    watchHistoryCleared: '观看记录已清空',
    clearWatchLater: '清空稍后再看',
    clearWatchLaterDescription: '清空当前账号保存的全部稍后再看章节。',
    confirmClearWatchLater: '确认清空稍后再看？',
    confirmClearWatchLaterDescription: '当前账号的全部稍后再看记录将被永久删除，此操作无法撤销。',
    watchLaterCleared: '稍后再看已清空',
    deleteWatchProgress: '删除观看记录',
    watchProgressDeleted: '观看记录已删除',
    applicationAppearance: '应用与界面',
    playbackPage: '播放',
    about: '关于',
    version: '版本',
    author: '作者',
    openSourceLicense: '开源许可',
    checkForUpdates: '检查更新',
    checkingForUpdates: '正在检查更新',
    updateAvailable: '发现新版本 {version}',
    updateUpToDate: '当前已是最新版本',
    updateVersionAhead: '当前版本高于最新发布版本',
    latestVersion: '最新版本',
    checkedAt: '检查时间 {time}',
    viewUpdate: '查看更新',
    aiIntegration: 'AI 集成',
    mediaResourceSelection: 'AI 媒体资源选择',
    useAiMediaSelection: '自动使用 AI 选择媒体资源',
    useAiMediaSelectionDescription:
      '启用后，点击章节播放时由 AI 自动选择媒体资源；关闭后可在资源对话框中手动使用 AI 帮选。',
    aiSelectionPrompt: '资源选择偏好',
    aiSelectionPromptPlaceholder: '例如：优先简体中文字幕、1080p 和 HEVC 编码',
    aiConnection: 'AI 连接',
    aiConnectionDescription: '配置供所有用户使用的 OpenAI Compatible API。',
    aiEnabled: '启用 AI 服务',
    aiApiUrl: 'API 地址',
    aiApiUrlPlaceholder: 'https://example.com/v1/chat/completions',
    aiApiKey: 'API Key',
    aiApiKeyPlaceholder: '留空则保留当前密钥',
    aiApiKeyUnavailable: 'AI Key 不可用，请重新输入并保存',
    clearAiApiKey: '清除已保存的密钥',
    aiModel: '模型',
    aiModelPlaceholder: '输入模型名称',
    aiServiceAvailable: 'AI 服务可用',
    aiServiceUnavailable: 'AI 服务尚未配置或已停用',
    aiSettingsSaved: 'AI 设置已保存',
    testAiConnection: '测试连接',
    aiConnectionSucceeded: 'AI 连接成功',
    aiSelectingMedia: 'AI 正在选择媒体资源…',
    aiHelpSelect: 'AI 帮选',
    aiSelectionFallback: 'AI 未找到可靠结果，请手动选择',
    aiServiceNotConfigured: 'AI 服务尚未配置',
    aiRequestFailed: 'AI 服务请求失败',
    aiResponseInvalid: 'AI 服务返回了无效结果',
    autoplay: '自动播放',
    autoplayDescription: '媒体准备完成后自动开始播放。',
    autoplayFailed: '自动播放失败，请手动点击播放按钮',
    autoPlayNextEpisode: '自动播放下一集',
    autoPlayNextEpisodeDescription: '当前章节播放结束后，如果下一集已经播出，则自动查找资源并继续播放。',
    autoMarkWatched: '自动标记',
    autoMarkWatchedDescription: '播放关联 Bangumi 章节的视频并看完时，自动将该章节标记为看过。',
    episodeAutoMarked: '已自动将该章节标记为看过',
    autoMarkRequiresBangumiToken: '自动标记需要先配置 Bangumi Token',
    subtitleSettings: '字幕设置',
    subtitleSettingsDescription: '设置播放器打开媒体时使用的默认字幕偏好。',
    showSubtitlesByDefault: '默认显示字幕',
    showSubtitlesByDefaultDescription: '媒体包含字幕时自动选择并显示字幕。',
    defaultSubtitleLanguage: '默认字幕语言',
    defaultSubtitleLanguageDescription: '优先选择匹配语言的字幕，没有匹配项时使用媒体默认字幕。',
    subtitleLanguageAuto: '自动选择',
    subtitleLanguageSimplifiedChinese: '简体中文',
    subtitleLanguageTraditionalChinese: '繁体中文',
    subtitleLanguageJapanese: '日语',
    subtitleLanguageEnglish: '英语',
    toggleThemeDescription: '选择跟随系统、浅色或深色显示模式。',
    themeFollowSystem: '跟随系统',
    themeLight: '浅色模式',
    themeDark: '深色模式',
    toggleLanguageDescription: '切换应用界面的显示语言。',
    showNsfw: '显示 NSFW 内容',
    showNsfwDescription: '允许搜索和推荐结果中包含成人向内容。',
    japaneseAnimeOnly: '只显示日本动画',
    japaneseAnimeOnlyDescription: '首页和时间表只显示日本动画。',
    showLateNightAnime: '时间表中显示深夜动画',
    showLateNightAnimeDescription: '将次日 00:00–02:00 播出的动画显示在前一天的 24:00–26:00 时段。',
    customizeHome: '自定义首页',
    customizeHomeDescription: '拖动板块调整首页顺序，或在显示与隐藏区域之间移动。',
    visibleContent: '显示内容',
    hiddenContent: '隐藏内容',
    usersDescription: '创建用户并管理已有用户的访问权限。',
    downloads: '下载',
    downloadsDescription: '管理下载任务、存储空间和 Tracker 设置。',
    subscriptions: '订阅',
    mediaSourceSettings: '媒体源设置',
    rssMediaProviders: 'RSS 媒体源',
    mediaProvidersDescription: '管理用于搜索动画种子和磁力资源的 RSS 媒体提供源。',
    addMediaProvider: '添加媒体源',
    mediaProviderId: '媒体源 ID',
    mediaProviderIdPlaceholder: '例如 nyaa',
    mediaProviderUrlTemplate: 'RSS URL 模板',
    mediaProviderUrlTemplatePlaceholder: 'https://example.com/rss?q={{ bangumi.nameCn }}+{{ episode.noPadded }}',
    mediaProviderTemplateContext: '模板上下文',
    mediaProviderTemplateContextDescription: '点击变量即可复制，模板变量会自动进行 URL 编码。',
    copyTemplateVariable: '复制模板变量',
    copyFailed: '复制失败',
    templateBangumiId: 'Bangumi 动画条目 ID',
    templateBangumiName: 'Bangumi 返回的动画原名',
    templateBangumiNameCn: 'Bangumi 返回的动画中文名',
    templateSitesSource: '数据来源：',
    templateSitesDescription: '每个项目的值代表该动画在对应站点中的条目 ID，不存在时为 undefined。',
    templateEpisodeId: 'Bangumi 章节条目 ID',
    templateEpisodeNo: '章节序号，不进行补零',
    templateEpisodeNoPadded: '两位补零的章节序号，例如 03',
    templateEpisodeSort: 'Bangumi 返回的章节排序编号',
    mediaProviderEnabled: '启用媒体源',
    mediaProviderCreated: '媒体源已添加',
    mediaProviderUpdated: '媒体源已更新',
    mediaProviderDeleted: '媒体源已删除',
    noMediaProviders: '尚未配置媒体源',
    editMediaProvider: '编辑媒体源',
    deleteMediaProvider: '删除媒体源',
    confirmDeleteMediaProvider: '确认删除此媒体源？',
    confirmDeleteMediaProviderDescription: '删除后将不再通过该 RSS 地址搜索媒体资源。',
    mediaResources: '媒体资源',
    mediaResourceDownloaded: '已下载',
    mediaResourcesDescription: '从已启用 RSS 媒体源搜索本集的种子和磁力链接。',
    searchingMediaResources: '正在搜索媒体资源…',
    noMediaResources: '没有找到可播放的媒体资源',
    mediaSourcePartialFailure: '部分媒体源搜索失败',
    playMediaResource: '播放',
    preparingMediaResource: '正在准备下载和播放…',
    sourcePage: '来源页面',
    downloadTasks: '下载任务',
    downloadTasksDescription: '查看并操作应用内的下载任务。',
    noDownloadTasks: '暂无下载任务',
    deleteDownload: '删除下载',
    confirmDeleteDownload: '确认删除下载任务？',
    confirmDeleteDownloadDescription: '该任务记录和本地文件将被永久删除，此操作无法撤销。',
    downloadDeleted: '下载任务已删除',
    storageSpace: '存储空间',
    storageSpaceDescription: '查看下载目录在当前磁盘中的空间占用。',
    downloadsFolder: 'Downloads 文件夹',
    diskCapacity: '磁盘总容量',
    diskFree: '磁盘可用空间',
    otherDiskUsage: '其他已用空间',
    downloadRetention: '下载任务保留时间',
    downloadRetentionDescription: '已完成任务超过保留时间后，每小时自动删除任务记录和对应的本地文件。',
    downloadRetentionHours: '保留时间（小时）',
    keepDownloadsForever: '永久保留（-1）',
    keepDownloadsForDays: '保留 {days} 天',
    transferRateLimits: '传输限速',
    transferRateLimitsDescription: '限制 WebTorrent 全局下载和上传带宽，-1 表示不限速，0 表示停止传输。',
    downloadRateLimit: '下载限速',
    uploadRateLimit: '上传限速',
    unlimitedRate: '不限制（-1）',
    stoppedRate: '停止（0）',
    useAdditionalTrackers: '使用额外 Trackers',
    useAdditionalTrackersDescription: '开始或恢复下载时使用 ngosang/trackerslist 最新 Tracker 列表，缓存有效期为一天。',
    trackerCache: 'Tracker 缓存',
    trackerCacheEmpty: '尚未缓存',
    trackerSourceRepository: '源仓库',
    clearDownloads: '清空下载',
    clearDownloadsDescription: '移除所有已完成下载的任务记录和本地文件，不影响正在下载的任务。',
    clearCompletedDownloads: '清空已完成下载',
    confirmClearDownloads: '确认清空已完成下载？',
    confirmClearDownloadsDescription: '所有已完成任务的记录和本地文件将被永久删除，此操作无法撤销。',
    completedDownloadsCleared: '已清空完成的下载任务',
    testToken: '测试 Token',
    generateToken: '生成 Token',
    tokenValid: 'Token 有效',
    tokenInvalid: 'Token 无效或已过期',
    tokenUpdated: 'Bangumi Token 已更新',
    bangumiTokenRequired: '请先配置 Bangumi Token',
    bangumiTokenInvalid: 'Bangumi Token 无效或已过期',
    bangumiTokenInvalidAlert: 'Bangumi Token 无效或已过期，收藏、追番和同步功能暂不可用。',
    bangumiTokenUnavailableAlert: '暂时无法验证 Bangumi Token，个性化功能可能不可用。',
    configureBangumiToken: '重新配置',
    recheckBangumiToken: '重新检测',
    passwordUpdated: '密码已更新',
    collectionUpdated: '收藏状态已更新',
    userCreated: '用户已创建',
    userDeleted: '用户已删除',
    requestFailed: '请求失败',
    requestFailedRetryLater: '请求错误，请稍后重试',
    networkError: '网络连接失败，请稍后重试',
    pwaUpdateAvailable: '发现新版本，更新后将重新载入应用',
    updateNow: '立即更新',
    routeNotFound: '请求的接口不存在',
    requestValidationFailed: '请求参数验证失败',
    invalidRequestBody: '请求内容格式无效',
    internalServerError: '服务器内部错误',
    updateCheckFailed: '检查更新失败，请稍后重试',
    wrongUsernameOrPassword: '用户名或密码错误',
    invalidSession: '登录状态无效或已过期',
    userNotFound: '用户不存在',
    authenticationRequired: '缺少登录凭证',
    invalidAuthorization: '登录凭证格式无效',
    insufficientPermissions: '没有执行此操作的权限',
    userAlreadyExists: '用户名已存在',
    cannotDeleteCurrentUser: '不能删除当前登录用户',
    wrongCurrentPassword: '当前密码错误',
    bangumiRequestFailed: 'Bangumi 请求失败',
    downloadNotFound: '下载任务不存在',
    downloadFailed: '下载失败',
    downloadFileNotFound: '下载文件不存在',
    invalidRange: '请求的文件范围无效',
    playbackChannelNotFound: '播放频道不存在',
    websocketUpgradeFailed: 'WebSocket 连接失败',
    mediaProviderNotFound: '媒体源不存在',
    mediaProviderAlreadyExists: '媒体源 ID 已存在',
    mediaProviderTemplateInvalid: '媒体源 URL 模板无效',
    mediaProviderRequestFailed: '媒体源请求失败',
    mediaResourceNotFound: '媒体资源不存在',
    mediaResourceExpired: '媒体资源已过期，请重新搜索',
    playback: '播放',
    playbackTitle: '播放媒体',
    copyVideoLink: '复制视频链接',
    videoLinkCopied: '视频链接已复制',
    openExternalPlayer: '在外部播放器中打开',
    openWithPotPlayer: '使用 PotPlayer 打开',
    openWithVlc: '使用 VLC 打开',
    downloadM3uPlaylist: '下载 M3U 播放列表',
    downloadVideoFile: '下载视频文件',
    externalPlaybackNotice:
      '外部播放器中的播放进度不会同步到 BGMer，也不会触发自动标记或自动播放下一集。若无法唤起播放器，请下载 M3U 播放列表或复制视频链接后手动打开。',
    torrentUrl: '种子网址',
    torrentUrlDescription: '支持 Magnet 链接和 HTTP(S) .torrent 地址。',
    torrentUrlPlaceholder: '粘贴 Magnet 或 .torrent 网址',
    clearInput: '清空输入内容',
    torrentUpload: '上传种子',
    torrentUploadDescription: '选择本地 .torrent 文件并解析其中的媒体。',
    parseAndPlay: '解析并播放',
    dropTorrentFile: '拖放或点击选择 .torrent 文件',
    torrentFileLimit: '文件大小不超过 5 MB',
    torrentFileRequired: '请选择 .torrent 文件',
    parsingTorrent: '正在解析种子元数据…',
    readingTorrentFiles: '正在读取种子文件列表…',
    preparingPlayback: '正在准备原始媒体播放…',
    nativePlaybackUnsupported: '浏览器无法直接播放此媒体格式或编码',
    torrentMetadataTimeout: '获取种子元数据超时',
    noMediaFiles: '种子中没有可播放的媒体文件',
    selectMediaFile: '选择要播放的文件',
    startPlayback: '开始播放',
    downloadSpeed: '下载速度',
    downloadProgress: '下载进度',
    downloadCompleted: '已完成',
    peers: 'Peers',
    playerPlay: '播放',
    playerPause: '暂停',
    playerMute: '静音',
    playerUnmute: '取消静音',
    playerFullscreen: '进入全屏',
    playerExitFullscreen: '退出全屏',
    playerProgress: '播放进度',
    playerTimelineUnavailable: '该部分尚不可选取',
    playerVolume: '音量',
    playbackSpeed: '播放倍速',
    subtitles: '字幕',
    subtitleOff: '关闭',
    subtitleUnavailable: '不可用',
    subtitleTimeOffset: '字幕时间偏移',
    subtitleTimeOffsetAhead: '字幕提前 0.5 秒',
    subtitleTimeOffsetBehind: '字幕延后 0.5 秒',
    resetSubtitleTimeOffset: '重置字幕时间偏移',
    danmaku: '弹幕',
    danmakuSettings: '弹幕设置',
    danmakuNotLoaded: '未加载',
    danmakuLoadedCount: '已加载 {count} 条弹幕',
    showDanmaku: '显示弹幕',
    danmakuFontSize: '字号',
    danmakuSpeed: '速度',
    danmakuOutline: '描边',
    danmakuShadow: '阴影',
    danmakuScaleSmall: '小',
    danmakuScaleMedium: '中',
    danmakuScaleLarge: '大',
    danmakuScaleExtraLarge: '超大',
    danmakuScaleSlow: '慢',
    danmakuScaleFast: '快',
    danmakuScaleExtraFast: '超快',
    danmakuXmlUrl: '联网弹幕 XML 地址',
    loadDanmakuXml: '加载',
    loadLocalDanmakuXml: '上传本地 XML',
    danmakuCorsHint: '联网 XML 需要源站允许浏览器跨域访问。',
    invalidDanmakuXml: '弹幕 XML 格式无效',
    noDanmakuComments: 'XML 中没有可用的弹幕',
    invalidDanmakuUrl: '请输入有效的 HTTP 或 HTTPS 地址',
    danmakuLoadFailed: '弹幕加载失败',
    playerPictureInPicture: '画中画',
    playerControls: '播放器控制栏',
    playerPlaybackControls: '播放控制',
    playerDisplayControls: '显示控制',
    playerWebFullscreen: '网页全屏',
    playerExitWebFullscreen: '退出网页全屏',
    playerOperationGuide: '操作说明',
    closePlayerOperationGuide: '关闭操作说明',
    closeExternalPlayerDialog: '关闭外部播放器对话框',
    playerGestureOperations: '鼠标与触控',
    playerKeyboardOperations: '键盘快捷键',
    playerOperationTap: '点击 / 轻触',
    playerOperationTapDescription: '显示或隐藏播放器控制栏',
    playerOperationDoubleTap: '双击 / 双击屏幕',
    playerOperationDoubleTapDescription: '播放或暂停视频',
    playerOperationLongPress: '长按',
    playerOperationLongPressDescription: '播放时临时使用 2 倍速，松开后恢复',
    playerOperationVerticalSwipe: '上下滑动',
    playerOperationVerticalSwipeDescription: '移动端调整音量',
    playerOperationHorizontalSwipe: '左右滑动',
    playerOperationHorizontalSwipeDescription: '移动端快退或快进，播放器全宽对应 90 秒',
    playerOperationPlayPause: '播放 / 暂停',
    playerOperationSeek: '快退 / 快进 5 秒',
    playerOperationVolume: '音量降低 / 提高 10%',
    playerOperationMute: '静音 / 取消静音',
    playerOperationFullscreen: '进入 / 退出全屏',
    passwordDescription: '修改当前登录用户的密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    updatePassword: '更新密码',
    users: '用户',
    createUser: '创建用户',
    welcome: '欢迎回到',
    loginDescription: '登录后浏览动画推荐、同步 Bangumi 在看列表与每日放送。',
    username: '用户名',
    password: '密码',
    login: '登录',
    settings: '设置',
    searchSettings: '搜索配置项',
    noSettingsFound: '未找到匹配的配置项',
    logout: '退出登录',
    cancel: '取消',
    confirm: '确认',
    confirmLogout: '确认退出',
    confirmLogoutDescription: '确定要退出当前账号吗？',
    deleteUser: '删除用户',
    deleteUserDescription: '该用户及其配置将被永久删除，此操作无法撤销。',
    refresh: '刷新',
    bgmTokenDescription: 'Token 仅发送到当前服务端并保存在数据库中，用于代理 Bangumi API 请求。',
    tokenPlaceholder: '留空可清除已保存的 Token',
    saveSettings: '保存设置',
    toggleTheme: '切换深浅色',
    toggleLanguage: '切换语言',
  },
  en: {
    staff: 'Staff',
    relatedSubjects: 'Related titles',
    expandAll: 'Show all',
    collapse: 'Collapse',
    home: 'Home',
    homeTitle: 'Discover',
    homeEmpty: 'There is nothing on your home page',
    homeEmptyDescription: 'Choose which sections to show from the settings page.',
    homeEmptyAction: 'Customize home',
    watchLater: 'Watch later',
    addWatchLater: 'Add to watch later',
    removeWatchLater: 'Remove from watch later',
    noWatchLater: 'No episodes saved for later',
    noContinueWatching: 'Nothing to continue watching',
    watchedPercent: '{percent}% watched',
    finishedWatching: 'Finished',
    watchedAt: 'Watched at {time}',
    popular: 'Popular now',
    todayUpdates: "Today's updates",
    myCollections: 'My collections',
    collectionRecords: 'Anime records',
    collectionStatusFilter: 'Collection status',
    noCollectionRecords: 'No anime records yet',
    viewMore: 'More',
    dateUnknown: 'Unknown date',
    my: 'My',
    watchHistory: 'History',
    noWatchHistory: 'No watch history',
    schedule: 'Schedule',
    scheduleFollowingOnly: 'Only show my watching list',
    scheduleDataSource: 'Broadcast data provided by bangumi-data',
    recommendations: 'Recommendations',
    randomAnime: 'Random',
    episodeAired: 'Aired',
    episodeUpcoming: 'Upcoming',
    selectAllEpisodes: 'Select all episodes',
    selectedEpisodes: 'Selected episodes',
    episodeUnwatched: 'Unwatched',
    episodeWish: 'Wish',
    episodeWatched: 'Watched',
    episodeDropped: 'Dropped',
    markEpisodeStatus: 'Mark status',
    markAs: 'Mark as',
    episodeStatusUpdated: 'Episode status updated',
    episodeLayout: 'Episode layout',
    multiSelect: 'Select multiple',
    exitSelection: 'Exit selection',
    episodeGridView: 'Switch to grid view',
    episodeListView: 'Switch to list view',
    loadMore: 'Load more',
    searchPlaceholder: 'Search anime…',
    searchResults: 'Search results',
    animeType: 'Type',
    region: 'Region',
    source: 'Source',
    rating: 'Rating',
    sort: 'Sort',
    noLimit: 'No limit',
    movie: 'Movie',
    japan: 'Japan',
    china: 'China',
    western: 'Western',
    original: 'Original',
    mangaAdaptation: 'Manga adaptation',
    novelAdaptation: 'Novel adaptation',
    gameAdaptation: 'Game adaptation',
    sortHeat: 'Popularity',
    sortScore: 'Score',
    sortRank: 'Rank',
    sortMatch: 'Relevance',
    summary: 'Summary',
    episodes: 'Episodes',
    characters: 'Characters & cast',
    collectionStatus: 'Collection status',
    collectionNone: 'Not collected',
    collectionWish: 'Wish',
    collectionDone: 'Completed',
    collectionDoing: 'Watching',
    collectionOnHold: 'On hold',
    collectionDropped: 'Dropped',
    collectionAll: 'All',
    openBangumi: 'Open in Bangumi',
    airDate: 'Premiere date',
    airTime: 'Air time',
    airTimeUnknown: 'Time TBD',
    platform: 'Platform',
    episodeCount: 'Episodes',
    contentUnavailable: 'Nothing here yet. Check your Bangumi token settings.',
    noContent: 'No content',
    changePassword: 'Change password',
    account: 'Account',
    clearWatchHistory: 'Clear watch history',
    clearWatchHistoryDescription:
      'Clear saved playback progress for the current account without deleting downloads or local files.',
    confirmClearWatchHistory: 'Clear watch history?',
    confirmClearWatchHistoryDescription:
      'All playback progress for the current account will be permanently deleted. This action cannot be undone.',
    watchHistoryCleared: 'Watch history cleared',
    clearWatchLater: 'Clear watch later',
    clearWatchLaterDescription: 'Clear every episode saved for later by the current account.',
    confirmClearWatchLater: 'Clear watch later?',
    confirmClearWatchLaterDescription:
      'All watch-later records for the current account will be permanently deleted. This action cannot be undone.',
    watchLaterCleared: 'Watch later cleared',
    deleteWatchProgress: 'Delete watch record',
    watchProgressDeleted: 'Watch record deleted',
    applicationAppearance: 'App & appearance',
    playbackPage: 'Playback',
    about: 'About',
    version: 'Version',
    author: 'Author',
    openSourceLicense: 'Open-source license',
    checkForUpdates: 'Check for updates',
    checkingForUpdates: 'Checking for updates',
    updateAvailable: 'Version {version} is available',
    updateUpToDate: 'You are using the latest version',
    updateVersionAhead: 'The current version is newer than the latest release',
    latestVersion: 'Latest version',
    checkedAt: 'Checked at {time}',
    viewUpdate: 'View update',
    aiIntegration: 'AI integration',
    mediaResourceSelection: 'AI media resource selection',
    useAiMediaSelection: 'Automatically select media with AI',
    useAiMediaSelectionDescription:
      'Automatically select media with AI when playing an episode. When disabled, AI selection remains available in the resource dialog.',
    aiSelectionPrompt: 'Resource preferences',
    aiSelectionPromptPlaceholder: 'For example: prefer Simplified Chinese subtitles, 1080p, and HEVC',
    aiConnection: 'AI connection',
    aiConnectionDescription: 'Configure the OpenAI Compatible API available to all users.',
    aiEnabled: 'Enable AI service',
    aiApiUrl: 'API URL',
    aiApiUrlPlaceholder: 'https://example.com/v1/chat/completions',
    aiApiKey: 'API Key',
    aiApiKeyPlaceholder: 'Leave blank to keep the current key',
    aiApiKeyUnavailable: 'AI Key is unavailable. Enter it again and save.',
    clearAiApiKey: 'Clear saved key',
    aiModel: 'Model',
    aiModelPlaceholder: 'Enter a model name',
    aiServiceAvailable: 'AI service available',
    aiServiceUnavailable: 'AI service is not configured or is disabled',
    aiSettingsSaved: 'AI settings saved',
    testAiConnection: 'Test connection',
    aiConnectionSucceeded: 'AI connection succeeded',
    aiSelectingMedia: 'AI is selecting a media resource…',
    aiHelpSelect: 'Select with AI',
    aiSelectionFallback: 'AI did not find a reliable result. Select one manually.',
    aiServiceNotConfigured: 'AI service is not configured',
    aiRequestFailed: 'AI service request failed',
    aiResponseInvalid: 'AI service returned an invalid response',
    autoplay: 'Autoplay',
    autoplayDescription: 'Start playback automatically when media is ready.',
    autoplayFailed: 'Autoplay failed. Click the play button to start playback.',
    autoPlayNextEpisode: 'Autoplay next episode',
    autoPlayNextEpisodeDescription:
      'When the current episode ends, automatically find and play the next episode if it has aired.',
    autoMarkWatched: 'Auto mark watched',
    autoMarkWatchedDescription: 'Mark the linked Bangumi episode as watched when playback is completed.',
    episodeAutoMarked: 'Episode automatically marked as watched',
    autoMarkRequiresBangumiToken: 'Configure a Bangumi token to use automatic marking',
    subtitleSettings: 'Subtitle settings',
    subtitleSettingsDescription: 'Choose the subtitle defaults used when opening media.',
    showSubtitlesByDefault: 'Show subtitles by default',
    showSubtitlesByDefaultDescription: 'Automatically select and display subtitles when they are available.',
    defaultSubtitleLanguage: 'Default subtitle language',
    defaultSubtitleLanguageDescription: 'Prefer matching subtitles, then fall back to the media default.',
    subtitleLanguageAuto: 'Auto select',
    subtitleLanguageSimplifiedChinese: 'Simplified Chinese',
    subtitleLanguageTraditionalChinese: 'Traditional Chinese',
    subtitleLanguageJapanese: 'Japanese',
    subtitleLanguageEnglish: 'English',
    toggleThemeDescription: 'Follow the system appearance or use a fixed light or dark mode.',
    themeFollowSystem: 'Follow system',
    themeLight: 'Light mode',
    themeDark: 'Dark mode',
    toggleLanguageDescription: 'Change the language used throughout the interface.',
    showNsfw: 'Show NSFW content',
    showNsfwDescription: 'Allow adult titles to appear in search and recommendation results.',
    japaneseAnimeOnly: 'Only show Japanese anime',
    japaneseAnimeOnlyDescription: 'Only show Japanese anime on the home page and schedule.',
    showLateNightAnime: 'Show late-night anime in schedule',
    showLateNightAnimeDescription:
      'Show anime airing from 00:00–02:00 on the previous day as part of its 24:00–26:00 schedule.',
    customizeHome: 'Customize home',
    customizeHomeDescription: 'Drag sections to reorder the home page or move them between visible and hidden.',
    visibleContent: 'Visible content',
    hiddenContent: 'Hidden content',
    usersDescription: 'Create users and manage access to this application.',
    downloads: 'Downloads',
    downloadsDescription: 'Manage download tasks, storage, and Tracker settings.',
    subscriptions: 'Subscriptions',
    mediaSourceSettings: 'Media source settings',
    rssMediaProviders: 'RSS media sources',
    mediaProvidersDescription: 'Manage RSS providers used to find anime torrents and magnet links.',
    addMediaProvider: 'Add media source',
    mediaProviderId: 'Provider ID',
    mediaProviderIdPlaceholder: 'For example, nyaa',
    mediaProviderUrlTemplate: 'RSS URL template',
    mediaProviderUrlTemplatePlaceholder: 'https://example.com/rss?q={{ bangumi.nameCn }}+{{ episode.noPadded }}',
    mediaProviderTemplateContext: 'Template context',
    mediaProviderTemplateContextDescription:
      'Click a variable to copy it. Template values are URL encoded automatically.',
    copyTemplateVariable: 'Copy template variable',
    copyFailed: 'Copy failed',
    templateBangumiId: 'Bangumi subject ID',
    templateBangumiName: 'Original subject name returned by Bangumi',
    templateBangumiNameCn: 'Chinese subject name returned by Bangumi',
    templateSitesSource: 'Data source:',
    templateSitesDescription:
      "Each item's value is the anime's subject ID on the corresponding site, or undefined when unavailable.",
    templateEpisodeId: 'Bangumi episode ID',
    templateEpisodeNo: 'Episode number without zero padding',
    templateEpisodeNoPadded: 'Two-digit zero-padded episode number, such as 03',
    templateEpisodeSort: 'Episode sort number returned by Bangumi',
    mediaProviderEnabled: 'Enable media source',
    mediaProviderCreated: 'Media source added',
    mediaProviderUpdated: 'Media source updated',
    mediaProviderDeleted: 'Media source deleted',
    noMediaProviders: 'No media sources configured',
    editMediaProvider: 'Edit media source',
    deleteMediaProvider: 'Delete media source',
    confirmDeleteMediaProvider: 'Delete this media source?',
    confirmDeleteMediaProviderDescription: 'This RSS address will no longer be used to search for media resources.',
    mediaResources: 'Media resources',
    mediaResourceDownloaded: 'Downloaded',
    mediaResourcesDescription: 'Search enabled RSS providers for torrents and magnet links for this episode.',
    searchingMediaResources: 'Searching media resources…',
    noMediaResources: 'No playable media resources found',
    mediaSourcePartialFailure: 'Some media sources failed',
    playMediaResource: 'Play',
    preparingMediaResource: 'Preparing download and playback…',
    sourcePage: 'Source page',
    downloadTasks: 'Download tasks',
    downloadTasksDescription: 'View and control downloads managed by this application.',
    noDownloadTasks: 'No download tasks',
    deleteDownload: 'Delete download',
    confirmDeleteDownload: 'Delete this download?',
    confirmDeleteDownloadDescription:
      'The download record and its local files will be permanently removed. This cannot be undone.',
    downloadDeleted: 'Download deleted',
    storageSpace: 'Storage space',
    storageSpaceDescription: 'See how much space the downloads directory uses on its current disk.',
    downloadsFolder: 'Downloads folder',
    diskCapacity: 'Disk capacity',
    diskFree: 'Disk free',
    otherDiskUsage: 'Other disk usage',
    downloadRetention: 'Download retention',
    downloadRetentionDescription:
      'Every hour, remove completed download records and local files that have exceeded the retention period.',
    downloadRetentionHours: 'Retention period (hours)',
    keepDownloadsForever: 'Keep forever (-1)',
    keepDownloadsForDays: 'Keep for {days} days',
    transferRateLimits: 'Transfer rate limits',
    transferRateLimitsDescription:
      'Limit global WebTorrent bandwidth. Set -1 for unlimited transfers or 0 to stop transfers.',
    downloadRateLimit: 'Download limit',
    uploadRateLimit: 'Upload limit',
    unlimitedRate: 'Unlimited (-1)',
    stoppedRate: 'Stopped (0)',
    useAdditionalTrackers: 'Use additional trackers',
    useAdditionalTrackersDescription:
      'Use the latest ngosang/trackerslist tracker list when starting or resuming downloads. The cache expires after one day.',
    trackerCache: 'Tracker cache',
    trackerCacheEmpty: 'Not cached yet',
    trackerSourceRepository: 'Source repository',
    clearDownloads: 'Clear downloads',
    clearDownloadsDescription:
      'Remove every completed download record and its local files without affecting active downloads.',
    clearCompletedDownloads: 'Clear completed downloads',
    confirmClearDownloads: 'Clear completed downloads?',
    confirmClearDownloadsDescription:
      'All completed download records and local files will be permanently removed. This cannot be undone.',
    completedDownloadsCleared: 'Completed downloads cleared',
    testToken: 'Test token',
    generateToken: 'Generate token',
    tokenValid: 'Token is valid',
    tokenInvalid: 'Token is invalid or expired',
    tokenUpdated: 'Bangumi token updated',
    bangumiTokenRequired: 'Configure a Bangumi token first',
    bangumiTokenInvalid: 'Bangumi token is invalid or expired',
    bangumiTokenInvalidAlert:
      'Your Bangumi token is invalid or expired. Collections, following, and sync features are unavailable.',
    bangumiTokenUnavailableAlert: 'The Bangumi token could not be verified. Personalized features may be unavailable.',
    configureBangumiToken: 'Configure again',
    recheckBangumiToken: 'Check again',
    passwordUpdated: 'Password updated',
    collectionUpdated: 'Collection updated',
    userCreated: 'User created',
    userDeleted: 'User deleted',
    requestFailed: 'Request failed',
    requestFailedRetryLater: 'Request failed. Please try again later.',
    networkError: 'Network connection failed. Please try again.',
    pwaUpdateAvailable: 'A new version is available. Updating will reload the app.',
    updateNow: 'Update now',
    routeNotFound: 'The requested endpoint was not found',
    requestValidationFailed: 'Request validation failed',
    invalidRequestBody: 'The request body is invalid',
    internalServerError: 'Internal server error',
    updateCheckFailed: 'Failed to check for updates. Please try again later.',
    wrongUsernameOrPassword: 'Wrong username or password',
    invalidSession: 'Your session is invalid or expired',
    userNotFound: 'User not found',
    authenticationRequired: 'Authentication is required',
    invalidAuthorization: 'The authentication header is invalid',
    insufficientPermissions: 'You do not have permission to perform this action',
    userAlreadyExists: 'Username already exists',
    cannotDeleteCurrentUser: 'You cannot delete the current user',
    wrongCurrentPassword: 'The current password is incorrect',
    bangumiRequestFailed: 'Bangumi request failed',
    downloadNotFound: 'Download not found',
    downloadFailed: 'Download failed',
    downloadFileNotFound: 'Downloaded file not found',
    invalidRange: 'The requested file range is invalid',
    playbackChannelNotFound: 'Playback channel not found',
    websocketUpgradeFailed: 'WebSocket connection failed',
    mediaProviderNotFound: 'Media source not found',
    mediaProviderAlreadyExists: 'Media source ID already exists',
    mediaProviderTemplateInvalid: 'Media source URL template is invalid',
    mediaProviderRequestFailed: 'Media source request failed',
    mediaResourceNotFound: 'Media resource not found',
    mediaResourceExpired: 'Media resource expired; search again',
    playback: 'Play',
    playbackTitle: 'Play media',
    copyVideoLink: 'Copy video link',
    videoLinkCopied: 'Video link copied',
    openExternalPlayer: 'Open in external player',
    openWithPotPlayer: 'Open with PotPlayer',
    openWithVlc: 'Open with VLC',
    downloadM3uPlaylist: 'Download M3U playlist',
    downloadVideoFile: 'Download video file',
    externalPlaybackNotice:
      'Playback progress in external players is not synced to BGMer and will not trigger automatic marking or autoplay the next episode. If the player cannot be opened, download the M3U playlist or copy the video link and open it manually.',
    torrentUrl: 'Torrent URL',
    torrentUrlDescription: 'Supports magnet links and HTTP(S) .torrent URLs.',
    torrentUrlPlaceholder: 'Paste a magnet or .torrent URL',
    clearInput: 'Clear input',
    torrentUpload: 'Upload torrent',
    torrentUploadDescription: 'Choose a local .torrent file and inspect its media files.',
    parseAndPlay: 'Parse and play',
    dropTorrentFile: 'Drop or choose a .torrent file',
    torrentFileLimit: 'Maximum file size: 5 MB',
    torrentFileRequired: 'Choose a .torrent file',
    parsingTorrent: 'Reading torrent metadata…',
    readingTorrentFiles: 'Reading the torrent file list…',
    preparingPlayback: 'Preparing the original media for playback…',
    nativePlaybackUnsupported: 'This media format or codec is not supported by your browser',
    torrentMetadataTimeout: 'Timed out while reading torrent metadata',
    noMediaFiles: 'No playable media files were found in this torrent',
    selectMediaFile: 'Choose a media file',
    startPlayback: 'Start playback',
    downloadSpeed: 'Download speed',
    downloadProgress: 'Download progress',
    downloadCompleted: 'Completed',
    peers: 'Peers',
    playerPlay: 'Play',
    playerPause: 'Pause',
    playerMute: 'Mute',
    playerUnmute: 'Unmute',
    playerFullscreen: 'Enter fullscreen',
    playerExitFullscreen: 'Exit fullscreen',
    playerProgress: 'Playback progress',
    playerTimelineUnavailable: 'This part is not seekable yet',
    playerVolume: 'Volume',
    playbackSpeed: 'Playback speed',
    subtitles: 'Subtitles',
    subtitleOff: 'Off',
    subtitleUnavailable: 'Unavailable',
    subtitleTimeOffset: 'Subtitle time offset',
    subtitleTimeOffsetAhead: 'Show subtitles 0.5 seconds earlier',
    subtitleTimeOffsetBehind: 'Show subtitles 0.5 seconds later',
    resetSubtitleTimeOffset: 'Reset subtitle time offset',
    danmaku: 'Danmaku',
    danmakuSettings: 'Danmaku settings',
    danmakuNotLoaded: 'Not loaded',
    danmakuLoadedCount: '{count} comments loaded',
    showDanmaku: 'Show danmaku',
    danmakuFontSize: 'Font size',
    danmakuSpeed: 'Speed',
    danmakuOutline: 'Outline',
    danmakuShadow: 'Shadow',
    danmakuScaleSmall: 'Small',
    danmakuScaleMedium: 'Medium',
    danmakuScaleLarge: 'Large',
    danmakuScaleExtraLarge: 'Extra large',
    danmakuScaleSlow: 'Slow',
    danmakuScaleFast: 'Fast',
    danmakuScaleExtraFast: 'Extra fast',
    danmakuXmlUrl: 'Online danmaku XML URL',
    loadDanmakuXml: 'Load',
    loadLocalDanmakuXml: 'Upload local XML',
    danmakuCorsHint: 'The XML source must allow cross-origin browser requests.',
    invalidDanmakuXml: 'Invalid danmaku XML',
    noDanmakuComments: 'No supported danmaku comments were found in the XML',
    invalidDanmakuUrl: 'Enter a valid HTTP or HTTPS URL',
    danmakuLoadFailed: 'Failed to load danmaku',
    playerPictureInPicture: 'Picture in picture',
    playerControls: 'Player controls',
    playerPlaybackControls: 'Playback controls',
    playerDisplayControls: 'Display controls',
    playerWebFullscreen: 'Web fullscreen',
    playerExitWebFullscreen: 'Exit web fullscreen',
    playerOperationGuide: 'Operation guide',
    closePlayerOperationGuide: 'Close operation guide',
    closeExternalPlayerDialog: 'Close external player dialog',
    playerGestureOperations: 'Mouse and touch',
    playerKeyboardOperations: 'Keyboard shortcuts',
    playerOperationTap: 'Click / tap',
    playerOperationTapDescription: 'Show or hide the player controls',
    playerOperationDoubleTap: 'Double-click / double-tap',
    playerOperationDoubleTapDescription: 'Play or pause the video',
    playerOperationLongPress: 'Press and hold',
    playerOperationLongPressDescription: 'Temporarily play at 2× speed; release to restore',
    playerOperationVerticalSwipe: 'Swipe vertically',
    playerOperationVerticalSwipeDescription: 'Adjust volume on mobile',
    playerOperationHorizontalSwipe: 'Swipe horizontally',
    playerOperationHorizontalSwipeDescription: 'Seek on mobile; the full player width represents 90 seconds',
    playerOperationPlayPause: 'Play / pause',
    playerOperationSeek: 'Seek backward / forward 5 seconds',
    playerOperationVolume: 'Decrease / increase volume by 10%',
    playerOperationMute: 'Mute / unmute',
    playerOperationFullscreen: 'Enter / exit fullscreen',
    passwordDescription: 'Update the password for your current account',
    currentPassword: 'Current password',
    newPassword: 'New password',
    updatePassword: 'Update password',
    users: 'Users',
    createUser: 'Create user',
    welcome: 'Welcome back to',
    loginDescription: 'Browse anime recommendations and sync your Bangumi watchlist and daily schedule.',
    username: 'Username',
    password: 'Password',
    login: 'Sign in',
    settings: 'Settings',
    searchSettings: 'Search settings',
    noSettingsFound: 'No matching settings found',
    logout: 'Sign out',
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirmLogout: 'Sign out?',
    confirmLogoutDescription: 'Are you sure you want to sign out of the current account?',
    deleteUser: 'Delete user',
    deleteUserDescription: 'This user and their settings will be permanently deleted. This action cannot be undone.',
    refresh: 'Refresh',
    bgmTokenDescription: 'The token is sent only to this server and stored for proxied Bangumi API requests.',
    tokenPlaceholder: 'Leave empty to remove the saved token',
    saveSettings: 'Save settings',
    toggleTheme: 'Toggle color theme',
    toggleLanguage: 'Change language',
  },
} as const;

export type MessageKey = keyof (typeof messages)['zh-CN'];

const LOCALE_KEY = 'bgmer.locale';
let locale: Locale = localStorage.getItem(LOCALE_KEY) === 'en' ? 'en' : 'zh-CN';

export const getLocale = (): Locale => locale;

export const t = (key: MessageKey): string => messages[locale][key];

export const setLocale = (nextLocale: Locale): void => {
  locale = nextLocale;
  localStorage.setItem(LOCALE_KEY, locale);
  document.documentElement.lang = locale;
};
